import gql from 'graphql-tag';

export default gql`
  mutation AddMeal($input: DailyTrackerAddDietMealInputType!) {
    dailyTracker {
      addDietMeal(input: $input) {
        ... on DailyTrackerAddDietMealSuccess {
          meal {
            id
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
      }
    }
  }
`;
